// removed by extract-text-webpack-plugin
module.exports = {"section-content":"object-detail__section-content___3MCav","toggle":"object-detail__toggle___lcC86","image":"object-detail__image___1-BNI","location-meta":"object-detail__location-meta___6Vytp","location-number":"object-detail__location-number___1Ss3-","location-caption":"object-detail__location-caption___lZSXT","slider-container":"object-detail__slider-container___xaI8K","is-visible":"object-detail__is-visible___1EPx3","is-hidden":"object-detail__is-hidden___uhK3C","has-icon-bar":"object-detail__has-icon-bar___iBMoR"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Object/Detail/object-detail.scss
// module id = 929
// module chunks = 0